import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Sidebar",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-sidebar",
    args: {},
    argTypes: {},
};

const Template = () => html`
    <ux-iws-sidebar>
        <ux-tab-container no-navigation>
            <ux-tab
                tab-id="contacts"
                name="Contacts"
                data-icon-name="contact-list"
            >
                Content
            </ux-tab>
            <ux-tab
                tab-id="frequently-searched-areas"
                name="Frequently searched"
                data-icon-name="squares-magnifier"
                >Content
            </ux-tab>
            <ux-tab tab-id="services" name="Services" data-icon-name="avatar"
                >Content
            </ux-tab>
            <ux-tab
                tab-id="downloads"
                name="downloads"
                data-icon-name="arrow-download"
                >Content
            </ux-tab>
            <ux-tab tab-id="calendar" name="Services" data-icon-name="calendar"
                >Content
            </ux-tab>
            <ux-tab tab-id="shop" name="shop" data-icon-name="cart"
                >Content
            </ux-tab>
            <ux-tab
                tab-id="social-share"
                name="Share"
                data-icon-name="share-nodes"
                >Content
            </ux-tab>
        </ux-tab-container>
    </ux-iws-sidebar>
`;

export const Default = Template.bind({});
Default.args = {};
